module.exports = __webpack_public_path__ + "static/media/unit-500.2b87b087.svg";